<template>
  <form>
    <div class="row">
      <div class="col-lg-12">
        <table
        class="table-bordered table-full-width border-primary"
                            cellpadding="20">
          <tr>
            <td>
        <h4 class="card-title">Full Proposal</h4>
        <a :href="downloadFiles[0][$i18n.locale]" class="btn btn-simple btn-primary">
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.appTemplateCompleted">{{$t('small_technical_grants.document_upload__completed_template_upload_title')}}</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.appTemplateCompleted"
            class="upload-file"
            :file-data="GrantForm.files.technical.appTemplateCompleted"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.appTemplateCompleted"
            >
          </upload-file>
        </div>
         </td>
      </tr>
      <tr>
        <td>
        <h4 class="card-title">Logical Framework</h4>
        <a :href="downloadFiles[1][$i18n.locale]" class="btn btn-simple btn-primary">
          {{$t('small_technical_grants.document_upload__download_template_button_title')}} <i class="tim-icons icon-cloud-download-93 ml-2"></i>
        </a>
        <div class="form-group">
          <span class="file-caption" v-if="!GrantForm.files.technical.logicalFramework">Upload here the completed template (Excel)</span>
          <upload-file
            v-if="GrantForm.initialized"
            v-model="GrantForm.files.technical.logicalFramework"
            class="upload-file"
            :file-data="GrantForm.files.technical.logicalFramework"
            :is-editable="GrantForm.isEditable"
            :size-limit="GrantForm.fileSizeLimit"
            section="technical.logicalFramework"
            >
          </upload-file>
        </div>
        </td>
        </tr>
        </table>
      </div>
    </div>

        

  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        downloadFiles: [
          {
            en: '/files/en/MG/FP/Region/'+GrantForm.regionId+'/technical_template.docx',
            fr: '/files/fr/MG/FP/Region/'+GrantForm.regionId+'/technical_template.docx'
          },
          {
            en: '/files/en/MG/FP/Region/'+GrantForm.regionId+'/logframe.xlsx',
            fr: '/files/fr/MG/FP/Region/'+GrantForm.regionId+'/logframe.xlsx'
          },
        ]
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
      addOtherDocument()
      {
        if (!GrantForm.model.technical.otherDocuments)
        {
          GrantForm.model.technical.otherDocuments = [];
        }

        GrantForm.model.technical.otherDocuments.push({});
        this.$forceUpdate();
      },
      mounted()
      {
        this.addOtherDocument();
      },
    }
  }
</script>
<style lang="scss" scoped>
.table-bordered td,
.table-bordered th
{
  padding: 20px;
}

.file-caption
{
  margin-right: 10px;
  display: inline-block;
  width: 60%;
}

.upload-file
{
  display: inline-block;
  margin-bottom: -4px;
}

.form-group
{
  border: 1px solid #ddd;
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 15px;
}

.card-title
{
  display: inline-block;
  width: 100%;
  margin-bottom: 1.75rem !important;
}
</style>
